// src/pages/SignUpPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

function SignUpPage({ setIsAuthenticated }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async () => {
    setLoading(true);
    setError(null);
    try {
      const registerResponse = await fetch('/api/register/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!registerResponse.ok) {
        throw new Error('Registration failed. Please check your data.');
      }

      const loginResponse = await fetch('/api/login/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!loginResponse.ok) {
        throw new Error('Login after registration failed.');
      }

      const loginData = await loginResponse.json();
      localStorage.setItem('token', loginData.access);

      if (setIsAuthenticated) {
        setIsAuthenticated(true);
      }

      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen font-sans">
      {/* Header */}
      <nav className="bg-[#0F2C5E] text-white p-4 flex items-center">
        <img src="/logo.png" alt="Logo" className="h-8 w-8 mr-2" />
        <span className="font-bold text-xl">2290Pay.org</span>
      </nav>

      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-center bg-[#E4F2FF] p-4">
        <div className="bg-white w-full max-w-md p-8 shadow-md rounded-md">
          <div className="flex space-x-8 mb-6 border-b border-gray-200">
            <Link to="/sign-in" className="text-[#0F2C5E] px-2 py-1 font-bold">
              SIGN IN
            </Link>
            <button className="text-[#0F2C5E] font-bold border-b-2 border-[#0F2C5E] px-2 py-1">
              SIGN UP
            </button>
          </div>

          {error && <div className="mb-4 text-red-500">{error}</div>}

          <div className="mb-4">
            <label className="block text-[#0F2C5E] mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value.toLowerCase())}
              placeholder="Enter your email"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0F2C5E]"
            />
          </div>

          <div className="mb-4">
            <label className="block text-[#0F2C5E] mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full p-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0F2C5E]"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500 text-sm focus:outline-none"
                tabIndex={-1}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <div className="flex items-center mb-6">
            <input
              type="checkbox"
              checked={keepSignedIn}
              onChange={e => setKeepSignedIn(e.target.checked)}
              className="mr-2"
            />
            <span className="text-[#0F2C5E]">Keep Me Signed In</span>
          </div>

          <button
            onClick={handleSignUp}
            disabled={loading}
            className={`w-full py-2 text-white bg-[#0F2C5E] rounded-md hover:bg-[#0F2C5E]/80 transition ${
              loading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {loading ? 'Creating account...' : 'SIGN UP'}
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default SignUpPage;
